(function($) {

  const header = () => { 
    const $toggler = $('#header button.toggler')
    const $header = $('#header')
    const $menu = $('#header ul.main-menu')
    const $submenuA = $('#header ul.main-menu li.has-submenu > a')

    const isMobile = window.matchMedia('(max-width: 991px)').matches
    
    $toggler.off('click')
    $submenuA.each(function() {
      $(this).off('click')
    })

    if (isMobile) {
      $toggler.on('click', function() {
        $menu.toggleClass('active')
        $header.toggleClass('active')
      })
      $submenuA.each(function() {
        $(this).on('click', function(e) {
          e.preventDefault()
          $(this).parent().toggleClass('submenu-active')
        })
      })
    }
  }

  $(function() {
    header()

    $(window).on('resize', function() {
      header()
    })
  })
})(jQuery);
